export default __webpack_public_path__ + "locales/ru/Settings.json?hash=5a121a446695f3399b6c650a55f76f50";